import {
    View,
    StyleSheet,
    Dimensions,
    Platform,
    Text
} from "react-native";
import { useTheme } from "@react-navigation/native";
import React from "react";
import { Controller } from 'react-hook-form';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import { Button, Checkbox, Menu } from "react-native-paper";
import DropDownPicker from "react-native-dropdown-picker";
import MultiSelect from "react-native-multiple-select";
import { SafeAreaView } from "react-native-safe-area-context";
import Select from 'react-select';
import RNPickerSelect from 'react-native-picker-select';
import { useTranslation } from "react-i18next";

var width = Dimensions.get("window").width;

const CustomControlledDropdown = ({
    control, name,
    rules = {},
    type = "PRIMARY", disabled = false, options = [], defValue = undefined }) => {

    const { colors } = useTheme();
    const styles = makeStyles(colors);
    const { t } = useTranslation();
    const pickerSelectStyles = pickerSelectStyle(colors);

    return (
        <View style={[
            styles.container,
            styles[`container_${type}`],
        ]}>
            <Controller
                control={control}
                name={name}
                rules={rules}
                render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                    <>
                        <RNPickerSelect
                            useNativeAndroidPickerStyle={false}
                            fixAndroidTouchableBug={true}
                            disabled={disabled}
                            placeholderTextColor="#a1a1a1"
                            placeholder={{
                                label: t('common:selectItem'),
                                value: '',
                                color: '#a1a1a1'
                            }}
                            value={value}
                            style={{
                                ...pickerSelectStyles,
                                iconContainer: {
                                    paddingVertical: 3,
                                    paddingHorizontal: 5,
                                },
                            }}
                            items={options}
                            Icon={() => (
                                Platform.OS !== 'web' && (
                                    <Ionicons
                                        name="chevron-down"
                                        style={styles.icon}
                                    />
                                )
                            )}
                            onValueChange={(value) => {
                                onChange(value);
                            }}
                        />
                        {error && (
                            <Text style={[styles[`error_${type}`], { color: 'red', alignSelf: 'stretch' }]}>{error.message || 'Error'}</Text>
                        )}
                    </>
                )}
            />
        </View>
    );
};
const makeStyles = (colors) => StyleSheet.create({

    container_SM_MYPROFILE: {
        flex: 1,
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        borderWidth: 2,
        width: '88%',
        padding: 10,
    },

    input_SM_MYPROFILE: {
        flex: 1,
        fontSize: 16,
        color: colors.text_primary,
        paddingHorizontal: 0,
    },

    container: {
        flex: 1,
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        borderWidth: 1.5,
        borderColor: colors.border_card,
        padding: Platform.OS === "web" ? 7 : 10,
        paddingHorizontal: Platform.OS !== "web" ? 10 : 7,
        marginVertical: 5,
        shadowColor: 'rgba(92, 143, 26, 1)',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.06,
        shadowRadius: 8,
        elevation: 2,
    },

    container_PART: {
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        borderWidth: 2,
        borderColor: colors.border_card,
        justifyContent: 'center',
    },

    input_PART: {
        fontSize: 16,
        color: colors.text_primary,
    },

    container_PRIMARY: {
        // Button Deloitte
        width: '60%',
    },

    container_FULL: {
        // Button Deloitte  
        flex: Platform.OS !== 'web' ? 1 : 100,
        backgroundColor: colors.background_dropdown,
        width: '94%',
        marginLeft: '3%',
        marginRight: '1%',
        paddingVertical: Platform.OS === 'web' && width > 1300 ? 5 : 7,
        marginBottom: '-1%',
    },

    container_ASSM: {
        flex: 1,
        backgroundColor: colors.background_dropdown,
        marginLeft: '3%',
        marginRight: '1%',
        paddingVertical: Platform.OS === 'web' && width > 1300 ? 5 : 7,
        marginBottom: '-1%',
    },

    container_RESULTS: {
        flex: Platform.OS !== 'web' ? 1 : 100,
        backgroundColor: colors.background_dropdown,
        width: '100%',
        marginLeft: '3%',
        marginRight: '1%',
        paddingVertical: Platform.OS === 'web' && width > 1300 ? 5 : 7,
        marginBottom: '-1%',
    },

    container_MYPROFILE: {
        flex: 1,
        width: '98%',
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        borderWidth: 2,
        padding: 10,
    },

    container_ASSESSMENT: {
        flex: 1,
        width: '100%',
        height: '6%',
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        borderWidth: 2,
        padding: 10,
    },

    container_MODAL: {
        borderRadius: 5,
        borderWidth: Platform.OS === 'web' && width > 1300 ? 0 : 2,
        backgroundColor: Platform.OS === 'web' && width > 1300 ? 'transparent' : colors.background_dropdown,
    },

    container_CALENDAR: {
        flex: 1,
    },

    container_TIMESHEET: {
        backgroundColor: colors.background_dropdown,
        borderColor: 'transparent',
        marginVertical: 5,
        borderWidth: 2,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        flex: 1,
        borderRadius: 10,
        marginVertical: 10,
        marginHorizontal: 10,
        padding: 3,
    },

    input_TIMESHEET: {
        flex: 1,
        fontSize: 16,
        color: colors.text_primary,
        paddingHorizontal: 0,
    },


    icon: {
        fontSize: 20,
        color: '#a1a1a1',
    },

    container_NEW_COMPANY: {
        flex: 1,
        borderRadius: 5,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
        borderRadius: 10,
        borderWidth: 2,
        padding: 10,
    },

    container_EDIT_EMPLOYEE: {
        backgroundColor: colors.background_dropdown,
        borderRadius: 10,
        borderWidth: 2,
        flex: 1,
        padding: 7,
        margin: 5,
    },
    error_EDIT_EMPLOYEE: {
        flex: 1,
        width: "100%",
        padding: 7,
        margin: 5,
    },

    container_EDIT_EMPLOYEE_REQUIRED: {
        borderRadius: 10,
        borderWidth: 2,
        borderColor: colors.background_rejected,
        flex: 1,
        width: "100%",
        padding: 7,
        margin: 5,
    },
    error_EDIT_EMPLOYEE_REQUIRED: {
        flex: 1,
        width: "100%",
        padding: 7,
        margin: 5,
    },
    container_WORKFLOW: {
        borderRadius: 10,
        borderWidth: 2,
        flex: 1,
        padding: 7,
        margin: 5,
        marginHorizontal: '5%'
    },
    error_WORKFLOW: {
        flex: 1,
        width: "100%",
        padding: 7,
        margin: 5,
        marginHorizontal: '5%'
    },
});
const pickerSelectStyle = (colors) => StyleSheet.create({

    inputIOS: {
        fontSize: 16,
        borderRadius: 10,
        borderColor: colors.border_card,
        borderWidth: 2,
        paddingVertical: 10,
        paddingHorizontal: 6,
        color: colors.text_primary,
        backgroundColor: colors.background_dropdown,
        paddingRight: 30, // to ensure the text is never behind the icon
        paddingLeft: 10,
        fontFamily: 'Roboto-Medium',
        overflow: 'hidden', // to hide overflow text
        textOverflow: 'ellipsis', // to add ellipsis for overflow text
    },

    inputAndroid: {
        fontSize: 16,
        color: colors.text_primary,
        paddingHorizontal: 5,
        backgroundColor: colors.background_dropdown,
        paddingRight: 30, // to ensure the text is never behind the icon
        fontFamily: 'Roboto-Medium',
        overflow: 'hidden', // to hide overflow text
        textOverflow: 'ellipsis', // to add ellipsis for overflow text
    },

    inputWeb: {
        fontSize: 16,
        color: colors.text_primary,
        paddingHorizontal: 5,
        backgroundColor: colors.background_dropdown,
        paddingRight: 30, // to ensure the text is never behind the icon
        fontFamily: 'Roboto-Medium',
        outlineStyle: 'none',    // remove dropdown outline
        borderColor: colors.background_dropdown,
        marginRight: 5,
        overflow: 'hidden', // to hide overflow text
        textOverflow: 'ellipsis', // to add ellipsis for overflow text
    },

    placeholder: {
        color: '#a1a1a1',
    },
});

export default CustomControlledDropdown;
